import { CategoryItemType } from '../api/getCategories';
import { TRootState } from '../reducers';
import { ArticleWithComponents, IArticleState, PresentedState } from '../reducers/types';

export const selectCategories = (state: TRootState): CategoryItemType[] | undefined => {
  return state.helpCenter.categories;
};

export const selectNormalizedCategories = (state: TRootState): Record<number, CategoryItemType> => {
  return state.helpCenter.normalizedCategories;
};

export const selectCurrentCategory = (state: TRootState) => {
  return state.helpCenter.currentCategory;
};

export const selectArticle = (state: TRootState): ArticleWithComponents | null => {
  return state.helpCenter.article.article;
};

export const selectArticleState = (state: TRootState): IArticleState => {
  return state.helpCenter.article;
};

export const selectCurrentPresentedState = (state: TRootState): PresentedState | undefined =>
  state.helpCenter.currentPresentedState;

export const selectIsHomepage = (state: TRootState): boolean =>
  state.helpCenter.currentPresentedState === PresentedState.Homepage;

export const selectPreviousPresentedState = (state: TRootState): PresentedState | undefined =>
  state.helpCenter.previousPresentedState;

export const selectSearchedText = (state: TRootState): string => state.helpCenter.searchedText;

export const selectSearchSessionId = (state: TRootState): string | undefined =>
  state.helpCenter.searchSessionId;

export const selectSearchInputType = (state: TRootState): string | undefined =>
  state.helpCenter.searchInputType;

export const selectIsSearchFocus = (state: TRootState): boolean => state.helpCenter.isSearchFocus;

export const selectArticleHeadingVisible = (state: TRootState) =>
  state.helpCenter.article.articleHeadingVisible;

export const selectFullPageSidebarOpened = (state: TRootState) => state.helpCenter.fullPageSidebarOpened;

export const selectFullPageSidebarExtended = (state: TRootState) => state.helpCenter.fullPageSidebarExtended;

export const selectHasHomeError = (state: TRootState): boolean => state.helpCenter.hasHomeError;
